<template>
  <v-app>
    <reader-dialog />
    <downlink-snackbar />
    <resolutions-snackbar />
    <v-content>
      <appstate-overlay v-if="showAppStateOverlay" :text="appState"/>
      <projectstate-overlay v-if="showProjectStateOverlay" :text="projectState"/>
      <encodererror-overlay v-if="showEncoderErrorOverlay" :text="errorState"/>
      <router-view/>
    </v-content>
  </v-app>
</template>

<script>
import { mapState } from 'vuex';

import AppStateOverlay from '@/components/overlays/AppState.vue';
import ProjectStateOverlay from '@/components/overlays/ProjectState.vue';
import EncoderErrorOverlay from '@/components/overlays/EncoderError.vue';
import UnsupportedResolutionsSnackbar from '@/components/snackbars/UnsupportedResolutions.vue';
import DownlinkSnackbar from '@/components/snackbars/Downlink.vue';
import ReaderDialog from '@/components/dialogs/Reader.vue';

export default {
  name: 'App',
  data() {
    return {};
  },
  watch: {
    '$store.state.currentHotspot': function() {
      // Bugherd feedback button is on top of fullsceen hotspot dialog close icon on mobile devices
      // Let's move button up 45 pixels when dialog is open
      const { currentHotspot } = this.$store.state;
      const isMobile = window.innerWidth < 600 ? true : false;
      const modifier = 45;
      const top = parseInt(document.getElementById('_BH_frame').style.top);

      if ( currentHotspot && isMobile) { // dialog opened
        document.getElementById('_BH_frame').style.top = top - modifier + 'px';
      } else if ( isMobile ) {  // dialog closed
        document.getElementById('_BH_frame').style.top = top + modifier + 'px';
      }
    }
  },
  async mounted() {
    if (process.env.VUE_APP_LOCALHOST !== 'true') {
      const bugherdScript = document.createElement('script');
      bugherdScript.setAttribute('src', 'https://www.bugherd.com/sidebarv2.js?apikey=ux1p451rxyhyhjetppuwvg');
      document.head.appendChild(bugherdScript);
    }
    console.log(process.env.VUE_APP_READER_VERSION);
  },
  components: {
    'appstate-overlay': AppStateOverlay,
    'projectstate-overlay': ProjectStateOverlay,
    'encodererror-overlay': EncoderErrorOverlay,
    'resolutions-snackbar': UnsupportedResolutionsSnackbar,
    'downlink-snackbar': DownlinkSnackbar,
    'reader-dialog': ReaderDialog,
  },
  computed: {
    ...mapState([
      'appState',
      'project',
    ]),
    showAppStateOverlay() {
      return (this.appState === 'INITIALIZING' || this.appState === 'LOADING');
    },
    showProjectStateOverlay() {
      if (!this.project) return false;
      const { fileState, content } = this.project;
      if (!fileState || content !== 'video') return false;
      if (fileState !== 'ENCODED' && fileState !== 'ERROR') return true;
      return false;
    },
    showEncoderErrorOverlay() {
      if (!this.project) return false;
      const { fileState, content } = this.project;
      if (!fileState || content !== 'video') return false;
      if (fileState === 'ERROR') return true;
      return false;
    },
    projectState() {
      if (!this.project) return false;
      const { fileState } = this.project;
      if (!fileState) return false;
      let text = '';
      switch (fileState) {
        case 'ENCODING':
          text = 'Project input encoding is in progress...';
          break;
        case 'WAITING':
          text = 'Project input is in encoding queue...';
          break;
        default:
          text = '';
          break;
      }
      return text;
    },
    errorState() {
      if (!this.project) return '';
      const { fileError } = this.project;
      if (!fileError) return '';
      return fileError;
    },
  },
};
</script>
